:host {
  --_gap-horizontal: var(--button-group-gap-horizontal);
  --_gap-vertical: var(--button-group-gap-vertical);

  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: var(--_gap-horizontal);
}

/* ---------- Orientation ---------- */

:host([orientation='vertical']) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--_gap-vertical);
}
